import React, {Component} from 'react';
import { connect } from 'react-redux';
import {Control, Form, Errors, actions} from 'react-redux-form';
import RegistrationAction from '../../actions/RegistrationAction';
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete'
import ErrorsConstants from "../../constants/ErrorsConstants";
import preloader from '../../image/preloader.gif';
import Select from 'react-select';
import MaskedTextInput from 'react-text-mask';

class Sign extends Component {
  componentDidMount() {
    this.props.resetForm();
    this.props.getMerchantTypes();
  }

  submit(data) {
    this.props.sendData(data);
  }

  changeForm() {
    this.props.resetValidation();
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  handleSelect(address) {
    geocodeByAddress(address).then(results => {
      let result = results[0].address_components;
      let line1 = '';
      let signForm = this.props.signForm;
      let addressResult = {
        line1: '',
        zip: null,
        city: null,
        state: null,
        country: null,
        latitude: results[0].geometry.location.lat(),
        longitude: results[0].geometry.location.lng()
      };
      for (var i = 0; i < result.length; ++i) {
        if (result[i].types[0] == 'street_number') {
          line1 += result[i].long_name + ' ';
        }
        if (result[i].types[0] == 'route') {
          line1 += result[i].long_name;
        }
        if (result[i].types[0] == 'postal_code') {
          addressResult.zip = result[i].long_name;
        }
        if (result[i].types[0] == 'postal_code') {
          addressResult.zip = result[i].long_name;
        }
        if (result[i].types[0] == 'administrative_area_level_1') {
          addressResult.state = result[i].long_name;
        }
        if (result[i].types[0] == 'locality') {
          addressResult.city = result[i].long_name;
        }
        if (result[i].types[0] == 'country') {
          addressResult.country = result[i].long_name;
        }
      }
      addressResult.line1 = line1;
      this.props.setAddressField(addressResult, signForm)
    })
      .catch(error => {
        console.log('Error:', error);
        this.setState({
          geocodeResults: error,
          loading: false,
        })
      })
  }

  handleChange(address) {
    this.props.setField('forms.signForm.line1', address);
  }

  handleChangeSelect(data) {
    this.props.setField('forms.signForm.types', data);
  }

  handleChangeInput(model, event) {
    this.props.setField(model, event);
  }

  render() {
    let {errors, requestStatus, signForm, types} = this.props;
    const optionsGooglePlaceAutocomplete = {
      types: ['address']
    };
    let typesOptions = [];
    types.forEach((item) => {
      typesOptions.push({value: item.code, label: item.name})
    });

    const inputProps = {
      type: 'text',
      autoComplete: 'randomstring',
      value: this.props.signForm.line1,
      onChange: this.handleChange.bind(this),
      placeholder: 'Address1',
      name: 'line1',
      id: 'line1',
    };

    const SelectTypes = (props) => <Select
                                      multi
                                      name="types"
                                      onChange={this.handleChangeSelect.bind(this)}
                                      value={signForm.types}
                                      options={typesOptions}
                                      {...props}
                                    />;

    return (
      <div className="row signup-box">
        <div className="col-md-8 col-md-offset-2">
          <Form model="forms.signForm"
                onSubmit={(data) => this.submit(data)}
                onChange={this.changeForm.bind(this)}
                className="sing-box" hideNativeErrors>
            <div className="form-group">
              <label htmlFor="name">Merchant name</label>
              <Control.text type="text required" model="forms.signForm.name" className="form-control" id="name"
                            placeholder="Name" autoComplete="randomstring"
                            validators={{
                              required: (val) => val && val.length
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.name"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Name merchant cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="name">Phone number</label>
              <MaskedTextInput
                mask={['+', '1', ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                className="form-control"
                placeholder="Enter a phone number" autoComplete="randomstring"
                onChange={(e) => this.handleChangeInput('forms.signForm.phone_number', e)}
                guide={false}
                id="my-input-id"
              />
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.phone_number"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Phone number cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <Control.text required type="email" model="forms.signForm.email" className="form-control" id="email"
                            placeholder="Email" autoComplete="randomstring"
                            validators={{
                              required: (val) => val && val.length,
                              email: (val) => val === '' || this.validateEmail(val)
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.email"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Email address cannot be blank',
                    email: 'Not a valid email format'
                  }}
                />
                {!errors.incorrectEntities.validation ? <div className="error">{errors.incorrectEntities.text}</div> : null}
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <Control.textarea maxLength="255" required className="form-control" model="forms.signForm.description" id="description"
                                placeholder="Description"
                                validators={{
                                  required: (val) => val && val.length
                                }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.description"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Description cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="website">Website</label>
              <Control.text className="form-control" model="forms.signForm.website" id="website" placeholder="www."/>
            </div>
            <div className="form-group">
              <label htmlFor="line1">Address 1</label>
              <PlacesAutocomplete
                options={optionsGooglePlaceAutocomplete}
                onSelect={this.handleSelect.bind(this)}
                onEnterKeyDown={this.handleSelect.bind(this)}
                inputProps={inputProps}
              />
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.line1"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Address 1 cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="line2">Address 2</label>
              <Control.text className="form-control" model="forms.signForm.line2" id="line2" placeholder="Address 2"/>
            </div>
            <div className="form-group">
              <label htmlFor="city">City</label>
              <Control.text className="form-control" required model="forms.signForm.city" id="city"
                            placeholder="City"
                            validators={{
                              required: (val) => val && val.length
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.city"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'City cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="state">State</label>
              <Control.text className="form-control" required model="forms.signForm.state" id="state"
                            placeholder="State"
                            validators={{
                              required: (val) => val && val.length
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.state"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'State cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="zip">Zip</label>
              <Control.text className="form-control" required model="forms.signForm.zip" id="zip"
                            placeholder="Zip"
                            validators={{
                              required: (val) => val && val.length
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.zip"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Zip cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group hidden">
              <label htmlFor="latitude">Latitude</label>
              <Control.text className="form-control" required model="forms.signForm.latitude" id="latitude"
                            placeholder="Latitude"
                            validators={{
                              required: (val) => val && val !== ''
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.latitude"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Latitude cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group hidden">
              <label htmlFor="longitude">Longitude</label>
              <Control.text className="form-control" required model="forms.signForm.longitude" id="longitude"
                            placeholder="Longitude"
                            validators={{
                              required: (val) => val && val !== ''
                            }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.longitude"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Longitude cannot be blank'
                  }}
                />
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="types">Merchant types</label>
              <Control model="forms.signForm.types" component={SelectTypes}
                       validators={{
                          required: (val) => val && val !== ''
                       }}/>
              <div className="error-box">
                <Errors
                  className="error"
                  model="forms.signForm.types"
                  show={(field) => field.submitFailed && !field.valid}
                  messages={{
                    required: 'Merchant types cannot be blank'
                  }}
                />
              </div>
            </div>
            <button disabled={requestStatus} type="submit" className="btn btn-action">Submit</button>
            <img src={preloader} style={{top: '-16px'}} className={requestStatus ? 'loader-button' : 'loader-button none'} alt="loading..." />
          </Form>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    currentStep: state.currentStep,
    requestStatus: state.requestStatus,
    errors: state.errors,
    types: state.types,
    signForm: state.forms.signForm,
  }),
  dispatch => ({
    getMerchantTypes: () => {
      dispatch(RegistrationAction.getMerchantTypes());
    },
    sendData: (data) => {
      dispatch(RegistrationAction.sendData(data));
    },
    resetForm: () => {
      dispatch(actions.reset('forms.signForm'));
      dispatch({type: ErrorsConstants.RESET_VALIDATION_STATUS, payload: 'incorrectEntities'});
    },
    resetValidation: () => {
      dispatch({type: ErrorsConstants.RESET_VALIDATION_STATUS, payload: 'incorrectEntities'});
    },
    setAddressField: (addressResult, signForm) => {
      dispatch(actions.change('forms.signForm', {
        name: signForm.name,
        email: signForm.email,
        description: signForm.description,
        phone_number: signForm.phone_number,
        website: signForm.website,
        types: signForm.types,
        line1: addressResult.line1 ? addressResult.line1 : signForm.line1,
        city: addressResult.city ? addressResult.city : signForm.city,
        state: addressResult.state ? addressResult.state : signForm.state,
        zip: addressResult.zip ? addressResult.zip : signForm.zip,
        latitude: addressResult.latitude ? addressResult.latitude : signForm.latitude,
        longitude: addressResult.longitude ? addressResult.longitude : signForm.longitude,
      }));
    },
    setField: (name, value) => {
      dispatch(actions.change(name, value));
    }
  })
)(Sign);


/** WEBPACK FOOTER **
 ** ./src/components/Sign/index.js
 **/